import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';

import {
  AddressAudit,
  BusinessPersonAudit,
  BusinessPersonSkeleton,
  EmailAddressAudit,
  EmergencyContactSkeleton,
  ExecutiveAssociateAudit,
  ExecutiveAssociateSkeleton,
  PersonAttributeAudit,
  PersonProfileAudit,
  PersonProfileSkeleton,
  PhoneNumberAudit,
  PreferenceAudit,
  PreferenceSkeleton,
  PersonAttributeSkeleton,
  StaffInfoAudit,
  CrewMemberTypeRatingSkeleton,
  CrewMemberTypeRatingAudit,
  TaxInfoAudit,
  PersonStaffGroupAudit,
  PassengerSkeleton,
  PassengerAudit
} from '../+models/person-profile-audit.model';
import { PersonProfileFacade } from '../+state/person-profile/person-profile.facade';

import { PersonProfileAuditListComponent } from './person-profile-audit-list/person-profile-audit-list.component';
import { PersonProfileEmergencyContactAuditListComponent } from './person-profile-emergency-contact-audit-list/person-profile-emergency-contact-audit-list.component';
import { PersonProfileExecutiveAssociateAuditListComponent } from './person-profile-executive-associate-audit-list/person-profile-executive-associate-audit-list.component';
import { PersonProfilePreferenceAuditListComponent } from './person-profile-preference-audit-list/person-profile-preference-audit-list.component';
import { PersonProfileAttributeAuditListComponent } from './person-profile-attribute-audit-list/person-profile-attribute-audit-list.component';
import { PersonProfileStaffDetailAuditListComponent } from './person-profile-staff-detail-audit-list/person-profile-staff-detail-audit-list.component';
import { PersonProfileBusinessPersonAuditListComponent } from './person-profile-business-person-audit-list/person-profile-business-person-audit-list.component';
import { PersonProfileCrewMemberTypeRatingAuditListComponent } from './person-profile-crew-member-type-rating-audit-list/person-profile-crew-member-type-rating-audit-list.component';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { PersonProfileTaxInfoAuditListComponent } from './person-profile-tax-info-audit-list/person-profile-tax-info-audit-list.component';
import { PersonProfilePersonStaffGroupAuditListComponent } from './person-profile-person-staff-groups-audit-list/person-profile-person-staff-groups-audit-list.component';
import { PersonProfilePassengerAuditListComponent } from './person-profile-passenger-audit-list/person-profile-passenger-audit-list.component';

@Component({
  selector: 'sd-portal-person-profile-audit',
  templateUrl: './person-profile.component.html',
  styleUrls: ['./person-profile.component.scss']
})
export class PersonProfileComponent implements OnInit {
  personProfileSkeletonLoading$: Observable<boolean>;
  personProfileSkeletonLoaded$: Observable<boolean>;
  personProfileSkeleton$: Observable<PersonProfileSkeleton | null | undefined>;

  personProfileAuditsLoading$: Observable<boolean>;
  personProfileAuditsLoaded$: Observable<boolean>;
  personProfileAudits$: Observable<PersonProfileAudit[]>;

  passengerAuditsLoading$: Observable<boolean>;
  passengerAuditsLoaded$: Observable<boolean>;
  passengerAudits$: Observable<PassengerAudit[]>;

  personAttributeAuditsLoading$: Observable<boolean>;
  personAttributeAuditsLoaded$: Observable<boolean>;
  personAttributeAudits$: Observable<PersonAttributeAudit[]>;

  businessPersonAuditsLoading$: Observable<boolean>;
  businessPersonAuditsLoaded$: Observable<boolean>;
  businessPersonAudits$: Observable<BusinessPersonAudit[]>;

  contactInfoAuditsLoading$: Observable<boolean>;
  contactInfoAuditsLoaded$: Observable<boolean>;

  addressAuditsLoading$: Observable<boolean>;
  addressAuditsLoaded$: Observable<boolean>;
  addressAudits$: Observable<AddressAudit[]>;

  phoneNumberAuditsLoading$: Observable<boolean>;
  phoneNumberAuditsLoaded$: Observable<boolean>;
  phoneNumberAudits$: Observable<PhoneNumberAudit[]>;

  emailAddressAuditsLoading$: Observable<boolean>;
  emailAddressAuditsLoaded$: Observable<boolean>;
  emailAddressAudits$: Observable<EmailAddressAudit[]>;

  emergencyContactAuditsLoading$: Observable<boolean>;
  emergencyContactAuditsLoaded$: Observable<boolean>;
  emergencyContactAudits$: Observable<EmailAddressAudit[]>;

  emergencyContactPhoneNumberAuditsLoading$: Observable<boolean>;
  emergencyContactPhoneNumberAuditsLoaded$: Observable<boolean>;
  emergencyContactPhoneNumberAudits$: Observable<PhoneNumberAudit[]>;

  executiveAssociateAuditsLoading$: Observable<boolean>;
  executiveAssociateAuditsLoaded$: Observable<boolean>;
  executiveAssociateAudits$: Observable<ExecutiveAssociateAudit[]>;

  executiveAssociatePhoneNumberAuditsLoading$: Observable<boolean>;
  executiveAssociatePhoneNumberAuditsLoaded$: Observable<boolean>;
  executiveAssociatePhoneNumberAudits$: Observable<PhoneNumberAudit[]>;

  executiveAssociateEmailAuditsLoading$: Observable<boolean>;
  executiveAssociateEmailAuditsLoaded$: Observable<boolean>;
  executiveAssociateEmailAudits$: Observable<EmailAddressAudit[]>;

  personStaffGroupAuditsLoading$: Observable<boolean>;
  personStaffGroupAuditsLoaded$: Observable<boolean>;
  personStaffGroupAudits$: Observable<PersonStaffGroupAudit[]>;

  preferenceAuditsLoading$: Observable<boolean>;
  preferenceAuditsLoaded$: Observable<boolean>;
  preferenceAudits$: Observable<PreferenceAudit[]>;

  preferenceCateringAuditsLoading$: Observable<boolean>;
  preferenceCateringAuditsLoaded$: Observable<boolean>;
  preferenceCateringAudits$: Observable<PreferenceAudit[]>;

  preferenceGroundTransportationAuditsLoading$: Observable<boolean>;
  preferenceGroundTransportationAuditsLoaded$: Observable<boolean>;
  preferenceGroundTransportationAudits$: Observable<PreferenceAudit[]>;

  preferenceHotelAuditsLoading$: Observable<boolean>;
  preferenceHotelAuditsLoaded$: Observable<boolean>;
  preferenceHotelAudits$: Observable<PreferenceAudit[]>;

  crewMemberTypeRatingTypesLoading$: Observable<boolean>;
  crewMemberTypeRatingTypesLoaded$: Observable<boolean>;
  crewMemberTypeRatingTypes$: Observable<RefTypeItem[]>;

  crewMemberTypeRatingAuditsLoading$: Observable<boolean>;
  crewMemberTypeRatingAuditsLoaded$: Observable<boolean>;
  crewMemberTypeRatingAudits$: Observable<CrewMemberTypeRatingAudit[]>;

  staffInfoAuditsLoading$: Observable<boolean>;
  staffInfoAuditsLoaded$: Observable<boolean>;
  staffInfoAudits$: Observable<StaffInfoAudit[]>;

  taxInfoAuditsLoading$: Observable<boolean>;
  taxInfoAuditsLoaded$: Observable<boolean>;
  taxInfoAudits$: Observable<TaxInfoAudit[]>;

  @ViewChildren(PersonProfileAuditListComponent)
  personProfileAuditLists: QueryList<PersonProfileAuditListComponent>;
  @ViewChildren(PersonProfileAttributeAuditListComponent)
  attributeAuditLists: QueryList<PersonProfileAttributeAuditListComponent>;
  @ViewChildren(PersonProfileBusinessPersonAuditListComponent)
  businessPersonAuditLists: QueryList<PersonProfileBusinessPersonAuditListComponent>;
  @ViewChildren(PersonProfileEmergencyContactAuditListComponent)
  emergencyContactAuditLists: QueryList<PersonProfileEmergencyContactAuditListComponent>;
  @ViewChildren(PersonProfileExecutiveAssociateAuditListComponent)
  executiveAssociateAuditLists: QueryList<PersonProfileExecutiveAssociateAuditListComponent>;
  @ViewChildren(PersonProfilePreferenceAuditListComponent)
  preferenceAuditLists: QueryList<PersonProfilePreferenceAuditListComponent>;
  @ViewChildren(PersonProfileCrewMemberTypeRatingAuditListComponent)
  crewMemberTypeRatingAuditLists: QueryList<PersonProfileCrewMemberTypeRatingAuditListComponent>;
  @ViewChildren(PersonProfilePersonStaffGroupAuditListComponent)
  personStaffGroupAuditLists: QueryList<PersonProfilePersonStaffGroupAuditListComponent>;
  @ViewChildren(PersonProfileStaffDetailAuditListComponent)
  staffDetailAuditLists: QueryList<PersonProfileStaffDetailAuditListComponent>;
  @ViewChildren(PersonProfileTaxInfoAuditListComponent)
  taxInfoAuditLists: QueryList<PersonProfileTaxInfoAuditListComponent>;
  @ViewChildren(PersonProfilePassengerAuditListComponent)
  passengerAuditLists: QueryList<PersonProfilePassengerAuditListComponent>;

  constructor(private readonly personProfileFacade: PersonProfileFacade) {}

  ngOnInit() {
    this.personProfileSkeletonLoaded$ = this.personProfileFacade.personProfileSkeletonLoaded;
    this.personProfileSkeletonLoading$ = this.personProfileFacade.personProfileSkeletonLoading$;
    this.personProfileSkeleton$ = this.personProfileFacade.personProfileAuditSkeleton$;

    this.personProfileAuditsLoading$ = this.personProfileFacade.personProfileAuditsLoading$;
    this.personProfileAuditsLoaded$ = this.personProfileFacade.personProfileAuditsLoaded$;
    this.personProfileAudits$ = this.personProfileFacade.personProfileAudits$;

    this.personAttributeAuditsLoading$ = this.personProfileFacade.attributeAuditsLoading$;
    this.personAttributeAuditsLoaded$ = this.personProfileFacade.attributeAuditsLoaded$;
    this.personAttributeAudits$ = this.personProfileFacade.attributeAudits$;

    this.businessPersonAuditsLoading$ = this.personProfileFacade.businessPersonAuditsLoading$;
    this.businessPersonAuditsLoaded$ = this.personProfileFacade.businessPersonAuditsLoaded$;
    this.businessPersonAudits$ = this.personProfileFacade.businessPersonAudits$;

    this.addressAuditsLoading$ = this.personProfileFacade.addressAuditsLoading$;
    this.addressAuditsLoaded$ = this.personProfileFacade.addressAuditsLoaded$;
    this.addressAudits$ = this.personProfileFacade.addressAudits$;

    this.phoneNumberAuditsLoading$ = this.personProfileFacade.phoneNumberAuditLoading$;
    this.phoneNumberAuditsLoaded$ = this.personProfileFacade.phoneNumberAuditLoaded$;
    this.phoneNumberAudits$ = this.personProfileFacade.phoneNumbersAudits$;

    this.emailAddressAuditsLoading$ = this.personProfileFacade.emailAddressAuditsLoading$;
    this.emailAddressAuditsLoaded$ = this.personProfileFacade.emailAddressAuditsLoaded$;
    this.emailAddressAudits$ = this.personProfileFacade.emailAddressAudits$;

    this.emergencyContactAuditsLoading$ = this.personProfileFacade.emergencyContactAuditsLoading$;
    this.emergencyContactAuditsLoaded$ = this.personProfileFacade.emergencyContactAuditsLoaded$;
    this.emergencyContactAudits$ = this.personProfileFacade.emergencyContactAudits$;

    this.emergencyContactPhoneNumberAuditsLoading$ =
      this.personProfileFacade.emergencyContactPhoneNumberAuditsLoading$;
    this.emergencyContactPhoneNumberAuditsLoaded$ =
      this.personProfileFacade.emergencyContactPhoneNumberAuditsLoaded$;
    this.emergencyContactPhoneNumberAudits$ =
      this.personProfileFacade.emergencyContactPhoneNumberAudits$;

    this.executiveAssociateAuditsLoading$ =
      this.personProfileFacade.executiveAssociateAuditsLoading$;
    this.executiveAssociateAuditsLoaded$ = this.personProfileFacade.executiveAssociateAuditsLoaded$;
    this.executiveAssociateAudits$ = this.personProfileFacade.executiveAssociateAudits$;

    this.executiveAssociatePhoneNumberAuditsLoading$ =
      this.personProfileFacade.executiveAssociatePhoneNumberAuditsLoading$;
    this.executiveAssociatePhoneNumberAuditsLoaded$ =
      this.personProfileFacade.executiveAssociatePhoneNumberAuditsLoaded$;
    this.executiveAssociatePhoneNumberAudits$ =
      this.personProfileFacade.executiveAssociatePhoneNumberAudits$;

    this.executiveAssociateEmailAuditsLoading$ =
      this.personProfileFacade.executiveAssociateEmailAuditsLoading$;
    this.executiveAssociateEmailAuditsLoaded$ =
      this.personProfileFacade.executiveAssociateEmailAuditsLoaded$;
    this.executiveAssociateEmailAudits$ = this.personProfileFacade.executiveAssociateEmailAudits$;

    this.personStaffGroupAuditsLoading$ = this.personProfileFacade.personStaffGroupAuditsLoading$;
    this.personStaffGroupAuditsLoaded$ = this.personProfileFacade.personStaffGroupAuditsLoaded$;
    this.personStaffGroupAudits$ = this.personProfileFacade.personStaffGroupAudits$;

    this.preferenceCateringAuditsLoading$ =
      this.personProfileFacade.preferenceCateringAuditsLoading$;
    this.preferenceCateringAuditsLoaded$ = this.personProfileFacade.preferenceCateringAuditsLoaded$;
    this.preferenceCateringAudits$ = this.personProfileFacade.preferenceCateringAudits$;

    this.preferenceGroundTransportationAuditsLoading$ =
      this.personProfileFacade.preferenceGroundTransportationAuditsLoading$;
    this.preferenceGroundTransportationAuditsLoaded$ =
      this.personProfileFacade.preferenceGroundTransportationAuditsLoaded$;
    this.preferenceGroundTransportationAudits$ =
      this.personProfileFacade.preferenceGroundTransportationAudits$;

    this.preferenceHotelAuditsLoading$ = this.personProfileFacade.preferenceHotelAuditsLoading$;
    this.preferenceHotelAuditsLoaded$ = this.personProfileFacade.preferenceHotelAuditsLoaded$;
    this.preferenceHotelAudits$ = this.personProfileFacade.preferenceHotelAudits$;

    this.crewMemberTypeRatingAuditsLoading$ = this.personProfileFacade.staffInfoAuditsLoading$;
    this.crewMemberTypeRatingAuditsLoaded$ =
      this.personProfileFacade.crewMemberTypeRatingAuditsLoaded$;
    this.crewMemberTypeRatingAudits$ = this.personProfileFacade.crewMemberTypeRatingAudits$;

    this.crewMemberTypeRatingTypesLoading$ =
      this.personProfileFacade.crewMemberTypeRatingTypesLoading$;
    this.crewMemberTypeRatingTypesLoaded$ =
      this.personProfileFacade.crewMemberTypeRatingTypesLoaded$;
    this.crewMemberTypeRatingTypes$ = this.personProfileFacade.crewMemberTypeRatingTypes$;

    this.staffInfoAuditsLoading$ = this.personProfileFacade.staffInfoAuditsLoading$;
    this.staffInfoAuditsLoaded$ = this.personProfileFacade.staffInfoAuditsLoaded$;
    this.staffInfoAudits$ = this.personProfileFacade.staffInfoAudits$;

    this.taxInfoAuditsLoading$ = this.personProfileFacade.taxInfoAuditsLoading$;
    this.taxInfoAuditsLoaded$ = this.personProfileFacade.taxInfoAuditsLoaded$;
    this.taxInfoAudits$ = this.personProfileFacade.taxInfoAudits$;

    this.passengerAuditsLoading$ = this.personProfileFacade.passengerAuditsLoading$;
    this.passengerAuditsLoaded$ = this.personProfileFacade.passengerAuditsLoaded$;
    this.passengerAudits$ = this.personProfileFacade.passengerAudits$;

    this.personProfileFacade.loadPersonProfileAudit();
    this.personProfileFacade.loadCrewMemberTypeRatingTypes();
  }

  personProfileOpened(personProfile: PersonProfileSkeleton) {
    setTimeout(() => {
      const match = this.personProfileAuditLists.find(c => c.personId === personProfile.personId);

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadProfileAudits(personId: number) {
    this.personProfileFacade.loadPersonProfileAudits(personId);
  }

  nextProfileAuditPage(personId: number) {
    this.personProfileFacade.nextPersonProfileAuditPage(personId);
  }

  passengerOpened(passengerProfile: PassengerSkeleton) {
    setTimeout(() => {
      const match = this.passengerAuditLists.find(
        c => c.passenger.passengerId === passengerProfile.passengerId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadPassengerAudits(personId: number) {
    this.personProfileFacade.loadPassengerAudits(personId);
  }

  nextPassengerAuditPage(passengerId: number) {
    this.personProfileFacade.nextPassengerAuditPage(passengerId);
  }

  personAttributeOpened(personAttribute: PersonAttributeSkeleton) {
    setTimeout(() => {
      const match = this.attributeAuditLists.find(
        a => a.personAttribute.personAttributeId === personAttribute.personAttributeId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadPersonAttributeAudits(personAttributeId: number) {
    this.personProfileFacade.loadPersonAttributeAudits(personAttributeId);
  }

  nextPersonAttributeAuditPage(personAttributeId: number) {
    this.personProfileFacade.nextPersonAttributeAuditPage(personAttributeId);
  }

  businessPersonOpened(businessPerson: BusinessPersonSkeleton) {
    setTimeout(() => {
      const match = this.businessPersonAuditLists.find(
        b => b.businessPerson.businessPersonId === businessPerson.businessPersonId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadBusinessPersonAudits(businessPersonId: number) {
    this.personProfileFacade.loadBusinessPersonAudits(businessPersonId);
  }

  nextBusinessPersonAuditPage(businessPersondId: number) {
    this.personProfileFacade.nextBusinessPersonAuditPage(businessPersondId);
  }

  loadAddressAudits(addressId: number) {
    this.personProfileFacade.loadAddressAudits(addressId);
  }

  nextAddressAuditPage(addressId: number) {
    this.personProfileFacade.nextAddressAuditPage(addressId);
  }

  loadPhoneNumberAudits(phoneNumberId: number) {
    this.personProfileFacade.loadPhoneNumberAudits(phoneNumberId);
  }

  nextPhoneNumberAuditPage(phoneNumberId: number) {
    this.personProfileFacade.nextPhoneNumberAuditPage(phoneNumberId);
  }

  loadEmailAddressAudits(emailAddressId: number) {
    this.personProfileFacade.loadEmailAddressAudits(emailAddressId);
  }

  nextEmailAddressAuditPage(emailAddressId: number) {
    this.personProfileFacade.nextEmailAddressAuditPage(emailAddressId);
  }

  emergencyContactOpened(emergencyContact: EmergencyContactSkeleton) {
    setTimeout(() => {
      const match = this.emergencyContactAuditLists.find(
        e => e.emergencyContact.emergencyContactId === emergencyContact.emergencyContactId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadEmergencyContactAudits(emergencyContactId: number) {
    this.personProfileFacade.loadEmergencyContactAudits(emergencyContactId);
  }

  nextEmergencyContactAuditPage(emergencyContactId: number) {
    this.personProfileFacade.nextEmergencyContactAuditPage(emergencyContactId);
  }

  loadEmergencyContactPhoneNumberAudits(emergencyContactPhoneNumberId: number) {
    this.personProfileFacade.loadEmergencyContactPhoneNumberAudits(emergencyContactPhoneNumberId);
  }

  nextEmergencyContactPhoneNumberAuditsPage(emergencyContactPhoneNumberId: number) {
    this.personProfileFacade.nextEmergencyContactPhoneNumberAuditPage(
      emergencyContactPhoneNumberId
    );
  }

  executiveAssociateOpened(executiveAssociate: ExecutiveAssociateSkeleton) {
    setTimeout(() => {
      const match = this.executiveAssociateAuditLists.find(
        e => e.executiveAssociate.executiveAssociateId === executiveAssociate.executiveAssociateId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadExecutiveAssociateAudits(executiveAssociateId: number) {
    this.personProfileFacade.loadExecutiveAssociateAudits(executiveAssociateId);
  }

  nextExecutiveAssociateAuditPage(executiveAssociateId: number) {
    this.personProfileFacade.nextExecutiveAssociateAuditPage(executiveAssociateId);
  }

  loadExecutiveAssociatePhoneNumberAudits(executiveAssociatePhoneNumberId: number) {
    this.personProfileFacade.loadExecutiveAssociatePhoneNumberAudits(
      executiveAssociatePhoneNumberId
    );
  }

  nextExecutiveAssociatePhoneNumberAuditsPage(executiveAssociatePhoneNumberId: number) {
    this.personProfileFacade.nextExecutiveAssociatePhoneNumberAuditPage(
      executiveAssociatePhoneNumberId
    );
  }

  loadExecutiveAssociateEmailAudits(executiveAssociateEmailId: number) {
    this.personProfileFacade.loadExecutiveAssociateEmailAudits(executiveAssociateEmailId);
  }

  nextExecutiveAssociateEmailAuditsPage(executiveAssociateEmailId: number) {
    this.personProfileFacade.nextExecutiveAssociateEmailAuditPage(executiveAssociateEmailId);
  }

  preferenceOpened(preference: PreferenceSkeleton) {
    this.personProfileFacade.resetPreferenceCateringAudits();

    setTimeout(() => {
      const match = this.preferenceAuditLists.find(
        p => p.preference.preferenceId === preference.preferenceId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadPreferenceCateringAudits(preferenceId: number) {
    this.personProfileFacade.loadPreferenceCateringAudits(preferenceId);
  }

  nextPreferenceCateringAuditsPage(preferenceId: number) {
    this.personProfileFacade.nextPreferenceCateringAuditPage(preferenceId);
  }

  loadPreferenceGroundTransportationAudits(preferenceId: number) {
    this.personProfileFacade.loadPreferenceGroundTransportationAudits(preferenceId);
  }

  nextPreferenceGroundTransportationAuditsPage(preferenceId: number) {
    this.personProfileFacade.nextPreferenceGroundTransportationAuditPage(preferenceId);
  }

  loadPreferenceHotelAudits(preferenceId: number) {
    this.personProfileFacade.loadPreferenceHotelAudits(preferenceId);
  }

  nextPreferenceHotelAuditsPage(preferenceId: number) {
    this.personProfileFacade.nextPreferenceHotelAuditPage(preferenceId);
  }

  crewMemberTypeRatingOpened(crewMemberTypeRating: CrewMemberTypeRatingSkeleton) {
    setTimeout(() => {
      const match = this.crewMemberTypeRatingAuditLists.find(
        c =>
          c.crewMemberTypeRating.crewMemberTypeRatingId ===
          crewMemberTypeRating.crewMemberTypeRatingId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadCrewMemberTypeRatingAudits(crewMemberTypeRatingId: number) {
    this.personProfileFacade.loadCrewMemberTypeRatingAudits(crewMemberTypeRatingId);
  }

  nextCrewMemberTypeRatingAuditsPage(crewMemberTypeRatingId: number) {
    this.personProfileFacade.nextCrewMemberTypeRatingAuditPage(crewMemberTypeRatingId);
  }

  personStaffGroupOpened(personStaffGroupId: number) {
    setTimeout(() => {
      const match = this.personStaffGroupAuditLists.find(
        s => s.personStaffGroup.personStaffGroupId === personStaffGroupId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadPersonStaffGroupAudits(personStaffPersonGroupId: number) {
    this.personProfileFacade.loadPersonStaffGroupAudits(personStaffPersonGroupId);
  }

  nextPersonStaffGroupAuditPage(personStaffPersonGroupId: number) {
    this.personProfileFacade.nextPersonStaffGroupAuditPage(personStaffPersonGroupId);
  }

  staffInfoOpened(staffInfoId: number) {
    setTimeout(() => {
      const match = this.staffDetailAuditLists.find(s => s.staffInfoId === staffInfoId);

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadStaffInfoAudits(staffInfoId: number) {
    this.personProfileFacade.loadStaffInfoAudits(staffInfoId);
  }

  nextStaffInfoAuditPage(staffInfoId: number) {
    this.personProfileFacade.nextStaffInfoAuditPage(staffInfoId);
  }

  taxInfoOpened(taxInfoId: number) {
    setTimeout(() => {
      const match = this.taxInfoAuditLists.find(t => t.taxInfo.taxInfoId === taxInfoId);

      if (!match) {
        return;
      }

      match.loadData();
    });
  }

  loadTaxInfoAudits(taxInfoId: number) {
    this.personProfileFacade.loadTaxInfoAudits(taxInfoId);
  }

  nextTaxInfoAuditPage(taxInfoId: number) {
    this.personProfileFacade.nextTaxInfoAuditPage(taxInfoId);
  }

  getCrewMemberTypeRatingTypeName(
    crewMemberTypeRatingTypes: RefTypeItem[],
    crewMemberTypeRatingTypeId: number
  ) {
    const crewMemberTypeRatingType = crewMemberTypeRatingTypes.find(
      c => c.id === crewMemberTypeRatingTypeId
    );
    if (!crewMemberTypeRatingType) {
      return 'N/A';
    }
    return crewMemberTypeRatingType.name;
  }
}
